export default __webpack_public_path__ + "static/media/stationsRompetrol.f9b5e02a.jpg";